import React, {useState} from 'react';
import UserProfile from "../components/Profile/UserProfile";
import { useAnalyticsPageView, useTranslations, useUserLanguage } from "examsbook-react-sdk/custom-hooks";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { useNavigate } from "react-router-dom";
import staticUrl from "RNExamsbookCommon/constants/staticUrl";
import {Translate as TranslateIcon, 
    MessageOutlined as MessageOutlinedIcon,
     ShareOutlined as ShareOutlinedIcon,
     StarOutlineOutlined as StarOutlineOutlinedIcon,
     LockOutlined as LockOutlinedIcon,
     AssignmentOutlined as AssignmentOutlinedIcon,
     ExitToAppOutlined as ExitToAppOutlinedIcon,
     ArrowDropDown as ArrowDropDownIcon,
} from '@material-ui/icons';
import FeedbackModel from "../components/Feedback/FeedbackModel";
import { saveFeedbackForm } from 'examsbook-react-sdk/actions/saveFeedback';
import { useDispatch } from 'react-redux';
/**
 * Setting component. right now it has only user profile section and selected exams of a user.
 * @param props
 * @returns {*}
 * @constructor
 */
function Settings(props) {
    const t = useTranslations();
    const navigate = useNavigate();
    const [ isFeedbackModelOpen, setIsFeedbackModelOpen ] = useState(false);
    const [open, setOpen] = useState(false);
    const { language, setUserLanguage } = useUserLanguage();
    const dispatch = useDispatch();
    useAnalyticsPageView();
    const openDropdown = () => {
        setOpen(!open);
    }
    function goToDashboard() {
        navigate('/my-app');
    }
    const logout = () => {
        window.location.href = '/logout';
    }
    const moveToPrivacyPolicy = () => {
        window.location.href = '/privacy-policy';
    }
    const moveToTermsConditionPage = () => {
        window.location.href = '/terms-conditions';
    }
    const rateApp = () => {
        window.location.href = staticUrl.PLAY_STORE_LINK;
    }
    const openFeedbackModel = () => {
        setIsFeedbackModelOpen(true);
    }

    const closeFeedBackModel = () => {
        setIsFeedbackModelOpen(false);
    }
    const submitFeedbackForm = (message) => {
        dispatch(saveFeedbackForm({ message: message }));
        closeFeedBackModel();
    }
    const settingOptions = [
        {
          title: t('feedback'),
          iconName: <MessageOutlinedIcon />,
          onPress: openFeedbackModel,
        },
        {
          title: t('RATE_ON_PLAY_STORE'),
          iconName: <StarOutlineOutlinedIcon />,
          onPress: rateApp,
        },
        {
          title: t('SHARE_APP'),
          iconName: <ShareOutlinedIcon />,
          onPress: rateApp,
        },
        {
          title: t('PRIVACY_POLICY'),
          iconName: <LockOutlinedIcon />,
          onPress: moveToPrivacyPolicy,
        },
        {
          title: t('TERMS_CONDITION'),
          iconName: <AssignmentOutlinedIcon />,
          onPress: moveToTermsConditionPage,
        },
        {
          title: t('logout'),
          iconName: <ExitToAppOutlinedIcon />,
          onPress: logout,
        },
    ]
    return (
        <>
            <div className="mobile-back-to-test">
                <ArrowBackIcon onClick={goToDashboard}/>
                <h4>{t('my_settings')}</h4>
            </div>
            <div className="settings">
                <h2>{t('my_settings')}</h2>
                <div className="tabs-section">
                    <div className="profile">
                        <UserProfile/>
                        {/* <UserSelectedExams classes={props.classes}/> */}
                        <div className="settingSection">
                            <div className="blockSection mobile-only">
                                <TranslateIcon />
                                <span>{t('LANGUAGE')}</span>
                                <div className={`${'languageSelector'}`} onClick={openDropdown}>
                                    {language === 'en' ?
                                    <div>{t('english')}</div> :
                                    <div>{t('hindi')}</div>}
                                   <ArrowDropDownIcon />
                                   <ul className={open ? 'open' : null}>
                                        <li className={language === 'en' ? 'selected' : ''} onClick={() => {
                                            setUserLanguage('en');
                                        }}>
                                            {t('english')}
                                        </li>
                                        <li className={language === 'hn' ? 'selected' : ''} onClick={() => {
                                            setUserLanguage('hn');
                                        }}>
                                            {t('hindi')}
                                        </li>
                                   </ul>
                                </div>
                            </div>
                            {settingOptions.map((items, i) => (
                                <div className="blockSection" key={i} onClick={items.onPress}>
                                    {items.iconName}
                                    <span>{items.title}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <FeedbackModel
                isFeedbackModelOpen={isFeedbackModelOpen}
                closeFeedBackModel={closeFeedBackModel}
                submitForm={submitFeedbackForm}/>
        </>
    );
}



export default Settings;
